import { all, takeLatest, put, call } from 'redux-saga/effects';
import {
    SHORT_LINK_REQUESTED,
    shortLinkFailed,
    shortLinkSucceeded,
} from './actions';
import {
    fetchWithoutAuth,
    getErrorsFromPossibleAPIErrorResponse,
} from '../utils/api';

function normalizeImageUrl(url) {
    if (!url) return null;
    // Add protocol if missing
    if (url.startsWith('localhost') || url.match(/^[\w.-]+:\d+/)) {
        return `http://${url}`;
    }
    return url;
}

export function* getShortLinkData(action) {
    const { shortCode } = action.payload;
    try {
        const data = yield call(fetchWithoutAuth, '/short_link/' + shortCode);
        const response = data.response || data;
        yield put(
            shortLinkSucceeded({
                ogTitle: response.ogTitle || response.og_title,
                ogDescription:
                    response.ogDescription || response.og_description,
                ogImage: normalizeImageUrl(
                    response.ogImage || response.og_image,
                ),
            }),
        );
    } catch (error) {
        const errors = yield call(
            getErrorsFromPossibleAPIErrorResponse,
            error,
            'Failed to retrieve shared content.',
        );
        yield put(shortLinkFailed(errors));
    }
}

export default function* shortLinksSaga() {
    yield all([takeLatest(SHORT_LINK_REQUESTED, getShortLinkData)]);
}
